export default __webpack_public_path__ + "static/media/video.7a9d64dc.svg";